module.exports = __webpack_public_path__ + "static/media/message.771482bc.mp3";